<template>
 <div>
     <div class="row">
         <div class="col-sm-12">
             <div class="page-title-box">
                 <div class="float-right">
                     <ol class="breadcrumb">
                         <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                         <li class="breadcrumb-item active">Pengaturan</li>
                     </ol>
                 </div>

                 <h4 class="page-title">
                     Pengaturan
                 </h4>
             </div>
         </div>
     </div>

     <div>
         <div class="row">
             <div class="col-lg-3">
                 <div class="card">
                     <div class="card-body">
                         <h4 class="header-title mt-0 mb-3">List Pengaturan</h4>
                         <div class="files-nav">
                             <div class="nav flex-column nav-pills" id="files-tab" aria-orientation="vertical">
                                <a class="nav-link active" id="profile-form-tab" data-toggle="pill" @click="selectedTab = 'profile'" aria-selected="true">
                                     <i class="em em-school mr-3 text-warning d-inline-block"></i>
                                     <div class="d-inline-block align-self-center">
                                         <h5 class="m-0">Profile</h5>
                                     </div>
                                 </a>
                                 <a class="nav-link" id="profile-form-tab" data-toggle="pill" @click="selectedTab = 'additional'" aria-selected="true"
                                    v-if="$store.state.permission.includes('company.setting.mandatory')">
                                     <i class="em em-page_facing_up mr-3 text-warning d-inline-block"></i>
                                     <div class="d-inline-block align-self-center">
                                         <h5 class="m-0">Tambahan</h5>
                                     </div>
                                 </a>
                                 <a class="nav-link" id="setting-form-tab" data-toggle="pill" @click="selectedTab = 'form'" aria-selected="true"
                                    v-if="$store.state.permission.includes('company.setting.mandatory')">
                                     <i class="em em-ledger mr-3 text-warning d-inline-block"></i>
                                     <div class="d-inline-block align-self-center">
                                         <h5 class="m-0">Formulir</h5>
                                     </div>
                                 </a>
                                 <a class="nav-link" id="setting-form-tab" data-toggle="pill" @click="selectedTab = 'payment'"
                                    v-if="$store.state.permission.includes('company.setting.mandatory')"
                                     aria-selected="false">
                                     <i class="em em-money_with_wings mr-3 text-warning d-inline-block"></i>
                                     <div class="d-inline-block align-self-center">
                                         <h5 class="m-0">Payment</h5>
                                     </div>
                                 </a>
                                 <!-- <a class="nav-link" id="setting-form-tab" data-toggle="pill" href="#setting-forfeit"
                                     aria-selected="false">
                                     <i class="em em-money_with_wings mr-3 text-warning d-inline-block"></i>
                                     <div class="d-inline-block align-self-center">
                                         <h5 class="m-0">Denda</h5>
                                     </div>
                                 </a> -->
                             </div>
                         </div>
                     </div>
                 </div>
             </div>

             <div class="col-lg-9">
                 <div class="tab-content" id="files-tabContent">

                     <div class="tab-pane fade show active" id="profile-form" v-if="selectedTab == 'profile'">
                         <div class="card">
                             <div class="card-body">
                                 <TabProfile />
                             </div>
                         </div>
                     </div>

                     <div class="tab-pane fade show active" id="setting-form" v-if="selectedTab == 'form'">
                         <div class="card">
                             <div class="card-body">
                                 <TabForm />
                             </div>
                         </div>
                     </div>

                     <div class="tab-pane fade show active" id="setting-payment" v-if="selectedTab == 'payment'">
                         <div class="card">
                             <div class="card-body">
                                 <TabPayment />
                             </div>
                         </div>
                     </div>

                     <div class="tab-pane fade show active" id="setting-payment" v-if="selectedTab == 'additional'">
                         <div class="card">
                             <div class="card-body">
                                 <OptionValue />
                             </div>
                         </div>
                     </div>

                     <!-- <div class="tab-pane fade" id="setting-forfeit" v-if="selectedTab == 'forfeit'">
                         <div class="card">
                             <div class="card-body">
                                 <TabForfeit />
                             </div>
                         </div>
                     </div> -->
                 </div>
             </div>
         </div>
     </div>
 </div>
</template>

<script>
import TabForm from './tabs/form'
import TabForfeit from './tabs/forfeit'
import TabProfile from './tabs/profile'
import TabPayment from './tabs/payment'
import OptionValue from './tabs/option_value'
export default {
    data(){
        return {
            selectedTab: 'profile'
        }
    },
    components: {
        TabForm,
        TabForfeit,
        TabProfile,
        TabPayment,
        OptionValue
    }
}
</script>

<style>

</style>
